export default {
  BIOMETHANE_GAS_TYPE: 'BIOMETHANE_GAS_TYPE',
  HYDROGEN_GAS_TYPE: 'HYDROGEN_GAS_TYPE',
};
